import Button from "@material-ui/core/Button";
import axios from "axios";
import MaterialTable from "material-table";
import React from "react";
import { store as storeNotification } from "react-notifications-component";
import { validate } from "../actions/authActions";
import { DOMAIN, IP } from "../config/IP";

const DocAccess = (props) => {
	const { useState } = React;

	const [columns, setColumns] = useState([
		{ title: "name", field: "name" },
		{ title: "email", field: "email" },
		{ title: "grantedDate", field: "grantedDate", editable: "never" },
		{ title: "notified", field: "notified", editable: "never" },
		{ title: "notifiedDate", field: "notifiedDate", editable: "never" },
		{ title: "type", field: "type", editable: "never" },
		{
			field: "notified",
			editable: "never",
			render: (rowData) => <Button>Re-Notify</Button>,
		},
	]);

	const [data, setData] = useState([]);
	console.log("DocAccess props.data=", props.data);

	React.useEffect(() => {
		console.log("props.data.data[0].share=", props.data.data[0]);
		try {
			setData(props.data.data[0].share);
		} catch (e) {}
	}, []);

	return (
		<MaterialTable
			title="Users List"
			columns={columns}
			data={data}
			editable={{
				onRowAdd: (newData) =>
					new Promise((resolve, reject) => {
						if (!newData.name || !newData.email) {
							storeNotification.addNotification({
								title: "failed!",
								message:
									"failed to grant access, field name and email must not be empty!",
								type: "danger",
								insert: "top",
								container: "top-right",
								animationIn: ["animated", "fadeIn"],
								animationOut: ["animated", "fadeOut"],
								dismiss: {
									duration: 5000,
									onScreen: true,
								},
							});

							reject();
							return;
						}
						console.log("newData=", newData);
						setTimeout(() => {
							if (validate(newData.email)) {
								// setData([...data, newData]);

								///api/grantDocAccess
								const token = localStorage.getItem("token");
								const config = {
									headers: {
										"x-auth-token": token,
										"content-type": "application/json",
									},
								};
								let insert = {
									action: "insertAccess",
									DocId: props.data.data[0].id,
									office_id: props.data.office_id,
									name: newData.name,
									email: newData.email.toLowerCase(),

									type: newData.email.toLowerCase().includes(DOMAIN)
										? "internal"
										: "external",
								};
								console.log("DocAccess insert=", insert);

								axios
									.post(IP.nodeServer + "api/grantDocAccess", insert, config)
									.then((response) => {
										console.log("DocAccess grantDocAccess response=", response);
										storeNotification.addNotification({
											title: "Access!",
											message: "Succefull granted",
											type: "success",
											insert: "top",
											container: "top-right",
											animationIn: ["animated", "fadeIn"],
											animationOut: ["animated", "fadeOut"],
											dismiss: {
												duration: 5000,
												onScreen: true,
											},
										});
										setData(response.data.share);
									})
									.catch((error) => {
										console.log("DocAccess grantDocAccess error=", error);
										storeNotification.addNotification({
											title: "failed!",
											message: "failed to grant access",
											type: "danger",
											insert: "top",
											container: "top-right",
											animationIn: ["animated", "fadeIn"],
											animationOut: ["animated", "fadeOut"],
											dismiss: {
												duration: 5000,
												onScreen: true,
											},
										});
										reject();
									});

								resolve();
							} else {
								storeNotification.addNotification({
									title: "failed!",
									message: "wrong email format",
									type: "danger",
									insert: "top",
									container: "top-right",
									animationIn: ["animated", "fadeIn"],
									animationOut: ["animated", "fadeOut"],
									dismiss: {
										duration: 5000,
										onScreen: true,
									},
								});
								reject();
							}
						}, 1000);
					}),

				onRowDelete: (oldData) =>
					new Promise((resolve, reject) => {
						setTimeout(() => {
							// setData([...data, newData]);

							///api/grantDocAccess
							const token = localStorage.getItem("token");
							const config = {
								headers: {
									"x-auth-token": token,
									"content-type": "application/json",
								},
							};
							let insert = {
								action: "deleteAccess",
								DocId: props.data.data[0].id,
								office_id: props.data.office_id,
								email: oldData.email.toLowerCase(),
							};
							console.log("DocAccess insert=", insert);

							axios
								.post(IP.nodeServer + "api/grantDocAccess", insert, config)
								.then((response) => {
									console.log("DocAccess grantDocAccess response=", response);
									storeNotification.addNotification({
										title: "Access!",
										message: "Succefull revoked",
										type: "success",
										insert: "top",
										container: "top-right",
										animationIn: ["animated", "fadeIn"],
										animationOut: ["animated", "fadeOut"],
										dismiss: {
											duration: 5000,
											onScreen: true,
										},
									});

									setData(response.data.share);
								})
								.catch((error) => {
									console.log("DocAccess grantDocAccess error=", error);
									storeNotification.addNotification({
										title: "failed!",
										message: "failed to revoke access",
										type: "danger",
										insert: "top",
										container: "top-right",
										animationIn: ["animated", "fadeIn"],
										animationOut: ["animated", "fadeOut"],
										dismiss: {
											duration: 5000,
											onScreen: true,
										},
									});
									reject();
								});

							resolve();
						}, 1000);
					}),
			}}
		/>
	);
};

export default DocAccess;
